
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from './cause-effect-explanation';
const mainimage = '/Images/causeandeffect1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "causeeffect" },
];

const Causeeffect = () => (
  <GrammarPageLayout
    level="B2"
    title="Cause and Effect"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English “because” and “so” Exercises"
    seoDescription="Practice Cause and Effect with interactive exercises for B2 level English exams."
    relatedCategory="grammar-exercises"
    relatedLevel="B2"
  />
);

export default Causeeffect;

